import { COLORS, FONT } from "../../constants";

export const LOGO_URL = "https://argusweb.azureedge.net/argus-web/logo.svg";

export const STEPS = [
  { number: 1, label: "Account Application" },
  { number: 2, label: "Documents Upload" },
  { number: 3, label: "Deed of Suretyship" },
  { number: 4, label: "Terms and Conditions" },
];

export const STEP1_FIELDS = [
  { key: "companyName", label: "COMPANY NAME", required: true },
  {
    key: "companyType",
    label: "COMPANY TYPE: (EG SPARE SHOP, FITMENT CENTRE, ETC)",
    required: true,
  },
  { key: "deliveryAddress", label: "DELIVERY ADDRESS", required: true },
  {
    key: "routingInstructions",
    label: "ROUTING INSTRUCTIONS",
    required: false,
  },
  { key: "contactName", label: "CONTACT NAME AND SURNAME", required: true },
  { key: "email", label: "EMAIL ADDRESS", required: true, type: "email" },
  { key: "phone", label: "PHONE NUMBER", required: true, type: "tel" },
  { key: "vatNumber", label: "VAT NO.", required: false },
];

export const APPLICANT_TYPE = {
  company: 1,
  individual: 2,
};

export const INITIAL_FORM = {
  companyName: "",
  companyType: "",
  deliveryAddress: "",
  deliveryAddressCoordinates: { lat: null, lng: null },
  routingInstructions: "",
  contactName: "",
  email: "",
  phone: "",
  vatNumber: "",
  companyRegNo: "",
  idNo: "",
};

export const INITIAL_FILES = {
  directorFiles: [],
  idVatFiles: [],
};

export const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "2px",
    "& fieldset": { borderColor: "#d0d0d0" },
    "&:hover fieldset": { borderColor: COLORS.themeBlack },
    "&.Mui-focused fieldset": {
      borderColor: COLORS.themeBlack,
      borderWidth: 1,
    },
  },
  "& .MuiInputBase-input": { fontSize: FONT.size.sm },
};

export const isDev = process.env.REACT_APP_ENVIRONMENT === "Development";
